import { useTenantStore } from '@afinius/hooks/store/useTenantStore';
import { defaultRouterOptions } from '@afinius/utilities/routing';
import { createRouter, createWebHistory, RouteLocationNormalized } from 'vue-router';

import AppLayout from './modules/app/views/layouts/AppLayout/AppLayout.vue';
import { routes as homeRoutes } from './modules/home/routes';
import { routes as personalSettingsRoutes } from './modules/personal-settings/routes';

const routes = [...homeRoutes, ...personalSettingsRoutes];

export const router = createRouter({
  history: createWebHistory('/'),
  routes: [
    {
      path: '/',
      component: AppLayout,
      children: routes,
    },
  ],
  ...defaultRouterOptions,
});

router.beforeEach(async (to, from) => {
  if (from.meta.delay) {
    await new Promise((resolve) => setTimeout(resolve, 100));
  }
});

const setTitle = (to: RouteLocationNormalized) => {
  const { tenant, onFetched } = useTenantStore();

  if (tenant) {
    document.title = `${to.meta.title} — ${tenant.title}`;
  } else {
    onFetched(() => setTitle(to));
  }
};

router.afterEach(setTitle);
